import axios from 'axios';
import config from '../../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';
import authHeaderFile from '../authHeaderFile';
import { updateProgress } from '../uploadFile';
import { setDownloadProgress } from '../downloadFile';
const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const getProjectList = createAsyncThunk(
    'get-project-list',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/GetProjectData`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const saveProject = createAsyncThunk(
    'save-project-detail',
    async (payload,{rejectWithValue}) => {
        try{
          const {data} = await axios.post(
            `${base_url}api/api/Project/SaveNewProject`,
            payload,
            {headers:authHeader()}
          );
          return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getProjectMemberList = createAsyncThunk(
    'get-member-list',
    async (payload,{rejectWithValue}) => {
        try{
          const {data} = await axios.post(
            `${base_url}api/api/Project/GetProjectMemberDetails`,
            payload,
            {headers:authHeader()}
          );
          return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

// Project/GetProjectMemberDropDown/${TenantID}
export const getDepartmentDetails = createAsyncThunk(
    'get-dept-list',
    async (id) => {
        try{
          const {data} = await axios.get(
            `${base_url}api/api/Project/GetProjectMemberDropDown/${id}`,
            {headers:authHeader()}
          );
          return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

//get single project detail
export const getProjectDetail=createAsyncThunk(
    'get-project-details',
    async(id) =>{
        try{
            const {data}=await axios.get(
                `${base_url}api/api/Project/GetProjectLists/${id}`,
                {headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }
);
// Project/GetFinancialByProjectRole/23/1116
export const getFinancialByRole=createAsyncThunk(
    'get-project-finance',
    async(id) =>{
        try{
            const {data}=await axios.get(
                `${base_url}api/api/Project/GetFinancialByProjectRole/${id}`,
                {headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }
);

//get project manager
export const getProjectManager = createAsyncThunk(
    'get-project-manager',
    async (id) =>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/GetProjectManagerDropDown/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }
);

//get project detail
export const getProjDetail=createAsyncThunk(
    'get-prj-detail',
    async (id) =>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/GetProjectDetailList/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);

// Project/UpdateProjectRoleAmount
export const saveProjectMember = createAsyncThunk(
    'save-prj-member',
    async (payload,{rejectWithValue}) => {
        try{
          const {data} = await axios.post(
            `${base_url}api/api/Project/SavePPProjectTeam`,
            payload,
            {headers:authHeader()}
          );
          return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
//delete project team member
export const deleteProjectMember=createAsyncThunk(
    'delete-teammember',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteProjectTeamMember/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);

//getproject milestone Project/GetMileStone
export const getMilestone=createAsyncThunk(
    'get-prj-milestone',
    async (id) =>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/GetMileStone/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);

//delete project Project/DeleteProject
export const deleteProject=createAsyncThunk(
    'delete-project',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteProject/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);

// save milestone
export const saveMilestone = createAsyncThunk(
    'save-milestone',
    async (payload,{rejectWithValue}) =>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/SaveMileStone`,
                payload,
            {headers:authHeader()}
            )
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data);
            }else{
                return rejectWithValue(error.response);
            }
        }
    }
);
//delete  milestone
export const deleteMilestone=createAsyncThunk(
    'delete-milestone',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteProjectMileStone/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);
// Project/SaveProjectTask// 
//save milestone
export const saveProjectTask = createAsyncThunk(
    'save-project-task',
    async (payload,{rejectWithValue}) =>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/SaveProjectTask`,
                payload,
            {headers:authHeader()}
            )
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data);
            }else{
                return rejectWithValue(error.response);
            }
        }
    }
);
//delete project task
export const deleteProjectTask=createAsyncThunk(
    'delete-projectTask',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteProjectTask/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);
// save milestone deliverable 
export const saveProjectDeliverable = createAsyncThunk(
    'save-project-deliverable',
    async (payload,{rejectWithValue}) =>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/SavePPProjectDeliverableType`,
                payload,
            {headers:authHeader()}
            )
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data);
            }else{
                return rejectWithValue(error.response);
            }
        }
    }
);

//delete milestone deliverable 
export const deleteDeliverable=createAsyncThunk(
    'delete-deliverable',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteDeliverableType/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);
// upload deliverable documents
let uploadprogress=0;
export const uploadDeliverableDoc = createAsyncThunk(
    'upload-deliverable document',
    async ({formData, apiUrl},{dispatch,rejectWithValue}) =>{
        try{
            const {data} = await axios.post(
                `${apiUrl}/api/Project/UploadProjectDeliverablesDocument`,
                formData,
                { 
                    onUploadProgress: (progressEvent) => {
                        uploadprogress = Math.round(
                         (progressEvent.loaded / progressEvent.total) * 100
                       );
                       dispatch(updateProgress(uploadprogress));
                     } ,headers: authHeaderFile() }
            )
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data);
            }else{
                return rejectWithValue(error.response.data);
            }
        }
    }
);

//download deliverable document
let progress=0;
export const downloadDeliverableDoc=createAsyncThunk(
    'download-deliverable document',
    async (id, { dispatch}) =>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/downloadDocs/${id}`,
                { 
                    onDownloadProgress: (progressEvent) => {
                        progress = Math.round(
                         (progressEvent.loaded / progressEvent.total) * 100
                       );
                      dispatch(setDownloadProgress(progress));
                    },
                    headers: authHeader(),
                } 
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);
//delete deliverable documents
export const deleteDeliverableDoc=createAsyncThunk(
    'delete-deliverable document',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/deleteDocs/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);

